import React from "react"
import GenericModal from "@irati/ui/src/GenericModal"
import {H2, Body} from "@irati/ui/src/Typography"
import {Card} from "@irati/ui/src/Layout"
import FormattedMessage from "@irati/utils/lang"
import mfa from "@irati/ui/images/mfa.png"

interface MFAModalProps {
  header: string,
  show?: boolean
}

const MFAModal: React.FC<MFAModalProps> = ({children, header, ...props}) => {
  return (
    <GenericModal critical hideActions image={mfa} small {...props}>
      <Body small marginBottom={1} textAlign="center">
        <H2>
          <FormattedMessage id={header} />
        </H2>
      </Body>
      <Card tiny noBorder>
        {children}
      </Card>
    </GenericModal>
  )
}

export default MFAModal
